import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { OWNER_MODULE_NAMESPACE, OWNER_GET_BLOCK_OWNERS } from '../../../../store/owner';
import { clearTimeout } from 'timers';
import { ApartmentParameter } from '../../../../models/apartment';

const OwnerStore = namespace(OWNER_MODULE_NAMESPACE)

@Component
class BlockSidebarWidgetOwners extends Vue {
  _clearTimeout: any;
  /**
   *
  
   */
  @OwnerStore.Action(OWNER_GET_BLOCK_OWNERS)
  storeGetBlockOwners: (payload: { blockId: string, param: any }) => Promise<any>
  @Prop({ default: null, type: [String] })
  path: string;

  @OwnerStore.Getter owners: any[];
  constructor(props) {
    super();
  }

  get coOwners() {
    return (this.owners || []).map(x => {
      let avatar: string = null;
      if (x.firstname.length === 0) {
        avatar = x.lastname.substring(0, 2);
      } else if (x.lastname.length === 0) {
        avatar = x.firstname.substring(0, 2);
      } else {
        avatar = x.firstname.substring(0, 1) + x.lastname.substring(0, 1)
      }

      return {
        id: x.id, firstname: x.firstname,
        avatar,
        lastname: x.lastname, name: `${x.firstname} ${x.lastname} `
      }
    })
  }
  isActive(id: number) {
    if (id.toString() === this.$route.params.cid)
      return 'turquoise';
    return ''
  }
  isActiveText(id: number) {
    if (id.toString() === this.$route.params.cid)
      return 'primary--text';
    return 'white--text'
  }
  redirectTo(id: number) {
    return {
      path: `/block/${this.$route.params.id}/owner/${id}`,
      params: { id: this.$route.params.id, cid: id.toString() }
    }
  }

  mounted() {
    this.getOwners(this.$route.params.id);
    this.$watch('$route.params', ({ id }, o) => this.storeGetBlockOwners({ blockId: id, param: new ApartmentParameter })
      .catch(error => console.log(error)));
  }

  getOwners(id: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeGetBlockOwners({ blockId: id, param: new ApartmentParameter })
        .catch(error => console.log(error))
    }, 300);
  }
}

export default BlockSidebarWidgetOwners;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-sidebar-widget-owners/index.ts